/**
 * equal heights - usage : equalheight('.blog-item h4')
 * @param el
 * @param val
 */
function setHeight(el, val) {
  if (typeof val === 'function') val = val();
  if (typeof val === 'string') el.style.height = val;
  else el.style.height = val + 'px';
}
const equalheight = function (container) {
  let currentTallest = 0
  let currentRowStart = 0
  let rowDivs = []

  Array.from(document.querySelectorAll(container)).forEach((el, i) => {
    el.style.height = 'auto';
    let topPosition = el.offsetTop
    let currentDiv
    if (currentRowStart !== topPosition) {
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        setHeight(rowDivs[currentDiv], currentTallest)
      }
      rowDivs.length = 0;
      currentRowStart = topPosition;
      currentTallest = parseFloat(getComputedStyle(el, null).height.replace('px', ''))
      rowDivs.push(el);
    } else {
      rowDivs.push(el);
      currentTallest = (currentTallest < parseFloat(getComputedStyle(el, null).height.replace('px', ''))) ? (parseFloat(getComputedStyle(el, null).height.replace('px', ''))) : (currentTallest);
    }
    for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
      setHeight(rowDivs[currentDiv], currentTallest)
    }
  })
}

export default equalheight;